import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { GasoilConsumptionPriceSource } from "__generated__/graphql";
import { DataFormat } from "utils";
import { Fragment, ReactNode } from "react";
import { CalculationMethodDetailsByTypeProps } from "@schemas/calculationmethods/schema";

type DetailsField = {
	id: string;
	render: () => ReactNode;
}

const GasoilConsumptionCalculationMethodDetails = ({ calculationMethod, currency, session, hiddenFields }: CalculationMethodDetailsByTypeProps) => {
	const GasoilConsumptionCalculationMethodDetailsFields: DetailsField[] = [
		{
			id: "calculationMethod.priceSource",
			render: () => (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "GASOIL_CONSUMPTION_PRICE_SOURCE" })} overflow="hidden">
						{intl.formatMessage({ id: `GASOIL_CONSUMPTION_PRICE_SOURCE_${calculationMethod.priceSource}` })}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.price",
			render: () => calculationMethod.priceSource === GasoilConsumptionPriceSource.Manual && (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "PRICE_PER_LITER" })} overflow="hidden">
						{DataFormat.price(calculationMethod.price, currency.isoCode, session.locale)}
					</FormGroup>
				</Grid>
			),
		},
		{
			id: "calculationMethod.referenceRateDateType",
			render: () => calculationMethod.priceSource === GasoilConsumptionPriceSource.Kbn && (
				<Grid size={4}>
					<FormGroup label={intl.formatMessage({ id: "REFERENCE_RATE_DATE_TYPE" })} overflow="hidden">
						{intl.formatMessage({ id: `REFERENCE_RATE_DATE_TYPE_${calculationMethod.referenceRateDateType}` })}
					</FormGroup>
				</Grid>
			),
		},
	];

	return (
		<>
			{GasoilConsumptionCalculationMethodDetailsFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default GasoilConsumptionCalculationMethodDetails;
